import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { Link, Redirect} from 'react-router-dom';
// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import RequestApi from '../Miscelania/RequestApi';
import Loading from '../Miscelania/Loading';
import Alerta from '../Miscelania/Alerta';
import Overlay from '../Miscelania/Overlay';

class ExamsAdd extends Component {
  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChangeStaff(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      nota_minima: '',
      setting_level_id: null,
      matter_id: null,
      staff_id: null,
      exam_start: null,
      lista_dificuldades: [],
      lista_materias: [],
      lista_alunos: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.adicionar = this.adicionar.bind(this);
    this.loadData = this.loadData.bind(this);
    this.handleSelectChangeStaff = this.handleSelectChangeStaff.bind(this);
    this.getNow = this.getNow.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  getNow() {
    var currentdate = new Date();
    var datetime = ("0" + currentdate.getDate()).slice(-2) + "/"
                    + ("0" + (currentdate.getMonth()+1)).slice(-2)  + "/"
                    + currentdate.getFullYear() + " "
                    + currentdate.toLocaleTimeString('en-GB', { hour: "numeric", minute: "numeric"})
                    + ':00';
    return datetime;
  }

  loadData(e) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/materias/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_materias: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_alunos: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/prova/dificuldades/listar';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_dificuldades: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); }); });
    });
  }

  adicionar(event) {
    event.preventDefault();
    var dados_salvar = {
      staff_id: this.state.staff_id,
      matter_id: this.state.matter_id,
      setting_level_id: this.state.setting_level_id,
      exam_start: this.state.exam_start,
    };
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/criar/prova/avulsa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar prova avulsa</h3>
      <Link to="/provas/listagem" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.adicionar}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Matéria:</label>
              <Select
                className="form-field-name"
                name="matter_id"
                value={this.state.matter_id}
                searchable={true}
                placeholder={'Selecione a matéria'}
                onChange={this.handleSelectChange.bind(this, 'matter_id')}
                options={this.state.lista_materias}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Aluno:</label>
              <Select
                className="form-field-name"
                name="staff_id"
                value={this.state.staff_id}
                searchable={true}
                multi={true}
                placeholder={'Selecione os alunos'}
                onChange={this.handleSelectChangeStaff.bind(this, 'staff_id')}
                options={this.state.lista_alunos}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nível de dificuldade:</label>
              <Select
                className="form-field-name"
                name="setting_level_id"
                value={this.state.setting_level_id}
                searchable={true}
                placeholder={'Selecione o nível de dificuldade'}
                onChange={this.handleSelectChange.bind(this, 'setting_level_id')}
                options={this.state.lista_dificuldades}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Data da prova:</label>
              <div className="row">
                <div className="col-md-10">
                  <InputMask value={this.state.exam_start}  maskChar={null} name="exam_start" mask="99/99/9999  99:99:99" className="form-control small-font-input" onChange={this.handleChange.bind(this, 'exam_start')} placeholder="dd/mm/yyyy hh:mm:ss" required/>
                </div>
                <div className="col-md-2">
                  <button type="button" className="btn btn-default" style={{cursor: 'pointer'}} onClick={() => this.setState({exam_start: this.getNow()})}><i className="fa fa-calendar"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Criar prova avulsa</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default ExamsAdd;



// WEBPACK FOOTER //
// ./src/Components/Exams/ExamsAdd.js